import { useCallback, useEffect, useState } from 'react';
import PackagesApi from '../api/paquetes';

const useAvailableDates = (originId, destinationId) => {
  const [availableDates, setAvailableDates] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAvailableDates = useCallback(async () => {
    if (!originId || !destinationId) {
      setAvailableDates(null);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      // Usar todos los IDs del array (joinados con comas) para mantener consistencia
      // con fetchDestinations que usa origin.id.join(',')
      const normalizedOriginId = Array.isArray(originId) ? originId.join(',') : originId;
      const normalizedDestinationId = Array.isArray(destinationId) ? destinationId.join(',') : destinationId;
      
      const data = await PackagesApi.getAvailableDates({
        originId: normalizedOriginId,
        destinationId: normalizedDestinationId
      });
      
      // Usar exactamente los datos que devuelve la API
      // Si la API devuelve { availableDates: { "2025": [7,8,9], "2026": [1,2] } }
      if (data && data.availableDates) {
        setAvailableDates(data.availableDates);
      } else {
        setAvailableDates(null);
      }
    } catch (err) {
      console.error('Error fetching available dates:', err);
      setError(err.message || 'Error al obtener las fechas disponibles');
      setAvailableDates(null);
    } finally {
      setIsLoading(false);
    }
  }, [originId, destinationId]);

  useEffect(() => {
    fetchAvailableDates();
  }, [fetchAvailableDates]);

  const refreshAvailableDates = useCallback(() => {
    fetchAvailableDates();
  }, [fetchAvailableDates]);

  return {
    availableDates,
    isLoading,
    error,
    refreshAvailableDates
  };
};

export default useAvailableDates; 